<div class="master-modal" role="dialog">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <!-- Modal-Header -->
      <div class="modal-header">
        <h4 class="modal-title"> Account Pay Request </h4>
        <div class="modal_close_btn">
          <span (click)="closeDialog('no')" class="modal-close"><i class="material-icons">close</i></span>
        </div>
      </div>
      <form class="form-section" [formGroup]="accountPayForm" (ngSubmit)="addUpdateSupplierAccount()">
        <!-- Modal content-->
      <perfect-scrollbar class="modal-body-scrollbar">
        <div mat-dialog-content>
          <div class="modal-body">
              <!-- Company Name-INPUT -->
              <div class="custom-form-group">
                <label class="custom-label" for="">Select Supplier <span class="star">*</span></label>
                <div class="custom-form-control">
                  <mat-form-field appearance="outline">
                    <mat-select formControlName="supplier_id" placeholder="Select supplier">
                      <mat-option *ngFor="let singleSupplier of dentalSupplierList"
                      [value]="singleSupplier.id">
                        {{singleSupplier.business_name}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="supplier_id.invalid && ( supplier_id.dirty || supplier_id.touched )">
                      <span>Please select supplier</span>
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <!-- Company Name-INPUT -->
              <div class="custom-form-group">
                <label class="custom-label" for="">Account Number<span class="star">*</span></label>
                <div class="custom-form-control">
                  <mat-form-field appearance="outline">
                    <input type="text" matInput placeholder="Enter account number" formControlName="account_number"
                    (focusout)="trimMe(account_number)" (keydown)="onlyNumbers($event)">
                    <mat-error *ngIf="account_number.invalid && ( account_number.dirty || account_number.touched )">
                      <span>Please provide a valid account Number</span>
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
          </div>
        </div>
      </perfect-scrollbar>
      <!-- Modal-Footer -->
      <div class="modal-footer">
        <div mat-dialog-actions class="modal_footer">
          <button type="button" mat-button (click)="closeDialog('no')" class="modal-cancel-btn modal-footer-btn">
            <span> Cancel </span>
          </button>
          <button type="submit" mat-button class="modal-save-btn global-btn">
            <span> Submit </span>
          </button>
        </div>
      </div>

    </form>

    </div>
  </div>
</div>
